import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-i18n-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import { Translator, TextHoc, TextHook } from "./components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "intro"
    }}>{`Intro`}</h1>
    <Translator page="index" num="0" mdxType="Translator" />
    <Translator page="index" num="1" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`$ npm i react-i18n-kit -S
`}</code></pre>
    <Translator page="index" num="2" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// './i18n/index.js'
const data = {
  en: {
    text: "Hello World!",
  },
  de: {
    text: "Hallo Welt!",
  },
};

export { data };
`}</code></pre>
    <Translator heading page="index" num="0" mdxType="Translator" />
    <Translator page="index" num="3" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React from "react";
import { useI18n } from "react-i18n-kit";

import { data } from "./i18n";

const TextHook = () => {
  const { i18n } = useI18n(data);

  return (
    <div>{i18n.text}</div>
  );
};

export { TextHook };
`}</code></pre>
    <Translator page="index" num="5" mdxType="Translator" />
    <Playground __position={6} __code={'<TextHook />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Translator,
      TextHoc,
      TextHook
    }} mdxType="Playground">
  <TextHook mdxType="TextHook" />
    </Playground>
    <Translator heading page="index" num="1" mdxType="Translator" />
    <Translator page="index" num="4" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React from "react";
import { withI18n } from "react-i18n-package";

import { data } from "./i18n";

const TextHoc = props => <div>{props.i18n.text}</div>;

const TextI18n = withI18n(TextHoc, data);

export { TextI18n as TextHoc };
`}</code></pre>
    <Translator page="index" num="5" mdxType="Translator" />
    <Playground __position={10} __code={'<TextHoc />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Translator,
      TextHoc,
      TextHook
    }} mdxType="Playground">
  <TextHoc mdxType="TextHoc" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      